module.exports = __webpack_public_path__ + "media/images/logo/gampla_purple-750830f1f88a49262dc008596fc6b138.png";